export const iconFontAwesomeHumanitarianEnvelope = (
	<i className="fa-solid fa-envelope"></i>
);
